import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { ApiError } from '../api/client'
import { deviceCfaQuery, saveDeviceCfa } from '../api/securitee'
import { toast } from '../ui/notify'

/**
 * Controlled Folder Access pe UN aparat, in fila Antiransomware: "Company
 * setting" (ce e pus in Settings > Securitee > Controlled Folder Access) sau o
 * treapta a lui - Off / Audit / Block. Dupa Save, FRC: agentul isi reciteste
 * setarile pe loc.
 *
 * Fara drept (403) sau fara aparat (404) randul nu se deseneaza.
 * TEXTELE sunt propuneri (28 septembrie 2026).
 */

const LABEL = ['Off', 'Audit', 'Block'] as const

export const CFA_DEVICE_TEXT =
  'Microsoft Defender ransomware prevention. Audit only records the applications that would be stopped; Block stops applications that are not allowed from changing files in protected folders. The allowed applications and folders are set in Settings > Securitee > Controlled Folder Access.'

export function CfaDeviceSetting({ id }: { id: number }) {
  const client = useQueryClient()
  const q = useQuery(deviceCfaQuery(id))
  const [choice, setChoice] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  if (q.error) {
    if (q.error instanceof ApiError && (q.error.status === 403 || q.error.status === 404)) return null
    return <div className="alert alert-danger">Something went wrong: {q.error.message}</div>
  }
  if (!q.data) return null
  const d = q.data
  const current = choice ?? (d.mode === null ? '' : String(d.mode))

  const save = async () => {
    if (busy) return
    setBusy(true)
    try {
      const body = await saveDeviceCfa(id, current === '' ? '' : (Number(current) as 0 | 1 | 2))
      client.setQueryData(['securitee', 'device', id, 'cfa'], body)
      setChoice(null)
      toast(body.message, 'Success', 'success')
    } catch (err) {
      toast(err instanceof ApiError ? err.message : 'Something went wrong.', 'Error', 'error')
    } finally {
      setBusy(false)
    }
  }

  return (
    <table className="table table-hover cfa-device">
      <tbody>
        <tr>
          <td className="a-left" style={{ width: 400 }}>
            <strong>Controlled Folder Access</strong>
            <div className="securitee-usb-limits securitee-block-text" style={{ fontSize: 11, color: '#7f8c8d', fontWeight: 400, marginTop: 4 }}>
              {CFA_DEVICE_TEXT}
            </div>
          </td>
          <td className="a-left">
            {d.ready ? (
              <>
                <select
                  className="form-control input-sm cfa-device-mode"
                  style={{ display: 'inline-block', width: 'auto' }}
                  aria-label="Controlled Folder Access"
                  value={current}
                  disabled={busy || !d.canWrite}
                  onChange={(e) => setChoice(e.target.value)}
                >
                  <option value="">Company setting ({LABEL[d.companyMode]})</option>
                  <option value="0">Off</option>
                  <option value="1">Audit</option>
                  <option value="2">Block</option>
                </select>{' '}
                {d.canWrite && (
                  <button type="button" className="btn btn-primary btn-sm cfa-device-save" disabled={busy || choice === null} onClick={() => void save()}>
                    Save
                  </button>
                )}
              </>
            ) : (
              <span className="text-muted cfa-device-off">Not available yet: the database migration has not run.</span>
            )}
          </td>
        </tr>
      </tbody>
    </table>
  )
}
